/** Shopify CDN: Minification failed

Line 14:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 15:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 19:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 20:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 21:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 22:13 Transforming let to the configured target environment ("es5") is not supported yet

**/
(function () {
    let interval = 5000;
    let selectorClass = ".swiper-slide";
    let activeClass = "active";

    let advanceAnnouncement = function () {
        let announcements = Array.from($(selectorClass));
        let lastAnnouncementIndex = announcements.length - 1;
        let activeAnnouncementIndex;
        for (let i = 0; i < announcements.length; i++) {
            if (announcements[i].classList.contains(activeClass)) {
                activeAnnouncementIndex = i;
            }
        }

        announcements[activeAnnouncementIndex].classList.remove(activeClass);
        activeAnnouncementIndex++;
        if (activeAnnouncementIndex > lastAnnouncementIndex) {
            activeAnnouncementIndex = 0;
        }
        announcements[activeAnnouncementIndex].classList.add(activeClass);




    }
    setInterval(advanceAnnouncement, interval);

})();